import { render, staticRenderFns } from "./EditRoleModal.vue?vue&type=template&id=23377cb5&scoped=true&"
import script from "./EditRoleModal.vue?vue&type=script&lang=js&"
export * from "./EditRoleModal.vue?vue&type=script&lang=js&"
import style0 from "./EditRoleModal.vue?vue&type=style&index=0&id=23377cb5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23377cb5",
  null
  
)

export default component.exports